// Utility component that scrolls the window back to the top on every route change.
// Mounted once in App.js outside the Routes tree so it fires on every navigation event.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
